import styled from 'styled-components';

export const UiEffectHighlighter = styled.div`
  border-radius: var(--cl-radius-2);
  transition: background-color 0.15s ease;

  &:focus {
    background-color: var(--cl-yellow-200);
    outline: none;
  }
`;
